//

//
//
//
//
// import Look from '~/components/templates/Look.vue';

import Default from '~/components/templates/Default.vue';
import ProductPage from '~/components/templates/ProductPage.vue';
import CheckoutPage from '~/components/templates/CheckoutPage.vue';
import ThankYouPage from '~/components/templates/ThankYouPage.vue';
import ProductListing from '~/components/templates/ProductListing.vue';
import ArticlePage from '~/components/templates/ArticlePage.vue';
import ArticleListing from '~/components/templates/ArticleListing.vue';
import SearchResults from '~/components/templates/SearchResults.vue';
import GiftCardPage from '~/components/templates/GiftCardPage.vue';
import ShopTheLook from '~/components/templates/ShopTheLook.vue';
import SupportPage from '~/components/templates/SupportPage.vue';

export default {
  'template-thank-you-page': ThankYouPage,
  'template-article-listing': ArticleListing,
  'template-product-list': ProductListing,
  'template-giftcard': GiftCardPage, // eslint-disable-line
  produkt: ProductPage,
  'template-checkout': CheckoutPage,
  'template-start': Default,
  'template-404': Default,
  'template-search-results': SearchResults,
  'template-support-page': SupportPage,
  'template-shop-the-look': ShopTheLook,
  // looks: Look,
  // page: Default,
  artiklar: ArticlePage,
  default: Default,
};
